import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor() { }

  openFileInTab(blob: Blob, fileType: string = 'application/pdf') {
    window.open(this.createFileUrl(blob, fileType), '_blank');
  }

  downloadFile(blob: Blob, filename: string = 'report.pdf', fileType: string = 'application/pdf') {
    const fileURL = this.createFileUrl(blob, fileType);
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.setAttribute('style', 'display: none');
    a.href = fileURL;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(fileURL);
    a.remove();
  }

  createFileUrl(blob: Blob, fileType: string = 'application/pdf') {
    const file = new Blob([blob], { type: fileType });
    return URL.createObjectURL(file);
  }
}
